import { useEffect, useState } from "react";
import { publicApi } from "../admin/api";

/**
 * Fetch CMS page content with synchronous fallback to defaults.
 *
 * Usage:
 *   const content = usePageContent("home", { intro_eyebrow: "..." });
 *
 * Returns the defaults immediately (so the page renders without flicker),
 * then merges in the CMS-saved data once the request resolves.
 */
export function usePageContent(key, defaults = {}) {
  const [data, setData] = useState(defaults);

  useEffect(() => {
    let cancelled = false;
    publicApi
      .get(`/page-content/${key}`)
      .then((r) => {
        if (!cancelled) setData({ ...defaults, ...r.data });
      })
      .catch(() => {
        /* keep defaults */
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return data;
}
